// Ada Chat feedback options constants

// Negative feedback options for individual chat messages
export const CHAT_MESSAGE_NEGATIVE_FEEDBACK_OPTIONS = [
  'Inaccurate information',
  'Unhelpful response',
  'Too long',
  'Too brief',
  'Off-topic',
  'Technical issues',
]

// General Ada Chat feedback options
export const ADA_CHAT_NEGATIVE_FEEDBACK_OPTIONS = [
  'Information was inaccurate or irrelevant',
  "Couldn't perform the requested task",
  'Instructions hard to follow',
  'Too slow',
  'Too wordy',
  "Doesn't understand my questions",
  'Interface is confusing',
  'Technical issues',
]

export const ADA_CHAT_POSITIVE_FEEDBACK_OPTIONS = [
  'Helpful responses',
  'Fast and efficient',
  'Understands my questions well',
  'Provides relevant information',
  'Easy to use interface',
  'Great overall experience',
]
